import { render, staticRenderFns } from "./TK035TeikiIkkatuListParts.vue?vue&type=template&id=2da14e10&"
import script from "./TK035TeikiIkkatuListParts.vue?vue&type=script&lang=js&"
export * from "./TK035TeikiIkkatuListParts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports